<div class="modal-container">
  <button
    id="modalDown"
    #modalDown
    data-bs-toggle="modal"
    data-bs-target="#modalD"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalD"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">Descargar archivo</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <p *ngIf="isAuth" class="p-tipografia-govco">
                {{ 'observatorio.descarga.msg-auth' | translate }}
              </p>
              <p *ngIf="!isAuth" class="p-tipografia-govco">
                {{ 'observatorio.descarga.msg-no-auth' | translate }}
              </p>
              <p class="p-tipografia-govco">
                {{ mensaje }}
              </p>
            </div>
          </div>
          <div class="mt-3 d-flex gap-2">
            <button
              type="button"
              class="btn-govco fill-btn-govco"
              (click)="descargar()"
              [disabled]="!enableBtn">
              Descargar
            </button>
            <button
              type="button"
              class="btn-govco btn-govco"
              data-bs-dismiss="modal">
              Salir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
